export default __webpack_public_path__ + "static/media/ISCO CLASS-5 EXAM PATTERN 2025.72131f0f.pdf";